import React, { useEffect, useState } from 'react'
import CourseCarousel from '../../CourseCarousel'
import CategoriesBanner from '../../CategoriesBanner'
import Navbar from '../../Navbar'
import config from '../../../config/config.json';
//import Footer from '../../Footer'
import RenderRazorpay from "../../utility/Render-Razor-pay";


export const Cart = () => {
    const { API_BASE_URL, RAZOR_PAY_API_KEY, RAZOR_PAY_API_SECRET } = config;

    const [total, setTotal] = useState(0);
    const [itemCount, setItemCount] = useState(0);
    const [coursePayload, setCoursePayload] = useState(null);
    const [displayRazorpay, setDisplayRazorpay] = useState(false);
    const [razorPayoderId, setrazorPayOrderId] = useState(null)

    const [courseCart, setcourseCart] = useState(() => {
        const savedCart = localStorage.getItem('cart');

        return savedCart ? JSON.parse(savedCart) : [];
    });

    const [userData, setUserData] = useState(() => {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : []
    })

    useEffect(() => {
        setItemCount(courseCart.length);

        const calculateTotal = () => {
            const newTotal = courseCart.reduce((acc, item) => acc + item.price, 0);
            setTotal(newTotal);
        };
        setCoursePayload(courseCart.map(course => ({
            CourseId: course.id,
            CourseName: course.name,
            Price: course.price
        })));

        calculateTotal();
    }, [courseCart]);

    const removeFromCart = (id) => {
        setcourseCart(prevCartItems => {
            const updatedCart = prevCartItems.filter(item => item.id !== id);
            setItemCount(updatedCart.length)
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            return updatedCart;
        });
    };

    const checkout = async () => {
        if (!courseCart || courseCart.length === 0) {
            alert("Cart is empty");
            return;
        }

        const orderItems = courseCart.map(course => ({
            CourseId: course.id,
            CourseName: course.name,
            Price: course.price
        }));

        try {
            const response = await fetch(`${API_BASE_URL}/api/cart/BuyCourse`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "UserId": userData?.result?.uuid
                },
                body: JSON.stringify({ orderItems })
            });

            if (response.ok) {
                const data = await response.json();
                console.log("Order created:", data);

                sessionStorage.setItem('courseOrderId', data.courseOrderId); 
                setrazorPayOrderId(data.razorPayoderId);
                setDisplayRazorpay(true);
            }
            else {
                const errorText = await response.text();
                console.error("API Error:", response.status, errorText);
                alert("Internal server error — check console");
            }

        } catch (error) {
            console.error("API call failed", error);
        }
    };

    return (
        <>
            <CategoriesBanner />
            <Navbar />

            <div class="grid sm:px-4 lg:grid-cols-6 lg:px-2 xl:px-16">
                <div class="px-4 pt-8 col-span-4">
                    <div className='px-9'>
                        <p class="text-4xl font-bold">Shopping Cart</p>
                        <p className='mt-8 -mb-2 text-xl font-medium'> {itemCount} Courses in cart</p>
                    </div>
                    <div class="space-y-3  bg-white px-2 py-4 sm:px-6">
                        {courseCart?.map((course, key) => (
                            <div class="flex flex-col  bg-white sm:flex-row border-t">
                                <img class="m-2 h-24 w-40 rounded-md border object-cover object-center" src={`${API_BASE_URL}/${course.courseThumbnail}`} alt="courseThumbnail" />
                                <div class="flex w-full flex-col px-4 py-4">
                                    <div class='grid grid-cols-8'>
                                        <span class="font-semibold col-span-6">{course?.name}</span>
                                        <button onClick={() => removeFromCart(course.id)} class='col-span-1 text-blue-500 font-serif'>Remove</button>
                                        <span class='col-span-1  font-bold'>₹{course?.price}</span>
                                    </div>

                                    <span class="float-right text-gray-400">{course?.userid}</span>
                                    <div className='flex items-center'>
                                        {Array.from({ length: 5 }, (_, index) => (
                                            <svg
                                                key={index}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                className="size-4 text-yellow-500"
                                            >
                                                {index < course.totalRating ? (
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                        clipRule="evenodd"
                                                    />
                                                ) : (
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M12 2c.674 0 1.316.337 1.682.909l2.083 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005c.366-.572 1.008-.909 1.682-.909Zm0 2.23l-1.733 4.166c-.183.441-.609.742-1.098.78l-4.393.353 3.323 2.847c.354.303.514.785.402 1.24l-1.014 4.249 3.573-2.181c.414-.253.938-.253 1.352 0l3.573 2.181-1.014-4.249c-.112-.455.048-.937.402-1.24l3.323-2.847-4.393-.353c-.49-.038-.915-.339-1.098-.78L12 4.23Z"
                                                        clipRule="evenodd"
                                                    />
                                                )}
                                            </svg>
                                        ))}
                                        <p className=" text-gray-700 text-[18px]">({course.totalRating}{course.noOfEnrollments}/204 Ratings )</p>

                                    </div>
                                    <div className=''>
                                        <ul className='flex lg:space-x-6 lg:gap-1 md:gap-0 md:space-x-4' >
                                            <li >
                                                <span>65 total hour</span>
                                            </li >
                                            <li className='  list-disc'>
                                                <span>667 lecture</span>
                                            </li>
                                            <li className='  list-disc'>
                                                <span>All level</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        ))}




                    </div>


                </div>
                <div class="mt-10 px-4 pt-8 lg:mt-0 col-span-2">
                    <div class="">

                        <div class="mt-20 flex flex-row   py-2">
                            <div class=" items-center">
                                <p class="text-xl font-medium text-gray-900">Total:</p>
                                <p class="font-bold text-gray-900 text-2xl">₹{total}.00</p>
                                <p class=" text-gray-600 "> <del>₹399.00</del></p>
                                <p class=" text-gray-900 ">86% off</p>


                            </div>

                        </div>

                    </div>
                    <button onClick={checkout} class="mt-4 mb-8 w-full rounded-md bg-gray-900 px-6 py-3 font-medium text-white">Checkout</button>
                </div>
                <h1 className='text-2xl font-bold'>You might also like</h1>

            </div>

            {displayRazorpay && (
                <RenderRazorpay
                    amount={Number(total)*100}
                    currency="INR"
                    orderId={razorPayoderId}
                    keyId={RAZOR_PAY_API_KEY}
                    keySecret={RAZOR_PAY_API_SECRET}
                />
            )}
            <CourseCarousel />


            <div>

            </div>

       
           {/* <Footer /> */}

        </>

    )
}

export default Cart
